import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UpcomingOccasionsCard = ({ occasions, onViewAll, onAddNew }) => {
  const getOccasionIcon = (type) => {
    switch (type?.toLowerCase()) {
      case 'birthday':
        return 'Cake';
      case 'anniversary':
        return 'Heart';
      case 'wedding':
        return 'Users';
      case 'graduation':
        return 'GraduationCap';
      case 'holiday':
        return 'Gift';
      default:
        return 'Calendar';
    }
  };

  const getUrgencyColor = (daysLeft) => {
    if (daysLeft <= 3) return 'text-red-600 bg-red-50 border border-red-200';
    if (daysLeft <= 7) return 'text-orange-600 bg-orange-50 border border-orange-200';
    return 'text-blue-600 bg-blue-50 border border-blue-200';
  };

  const formatDaysLeft = (daysLeft) => {
    if (daysLeft === 0) return 'Today';
    if (daysLeft === 1) return 'Tomorrow';
    return `${daysLeft} days`;
  };

  const handleFindGift = (occasion) => {
    console.log('Finding gift for occasion:', occasion);
    // TODO: Navigate to gift finder with occasion context
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-soft border border-accent-100">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
            <Icon name="Calendar" size={24} className="text-blue-600" />
          </div>
          <div>
            <h3 className="font-heading text-xl font-semibold text-accent-800">Upcoming Occasions</h3>
            <p className="text-sm text-accent-600">{occasions.length} events this month</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={onViewAll}
          className="text-blue-600 hover:text-blue-700 hover:bg-blue-50"
        >
          View All
        </Button>
      </div>

      <div className="space-y-4">
        {occasions.slice(0, 4).map((occasion) => (
          <div key={occasion.id} className="flex items-center justify-between p-5 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors duration-200 border border-gray-200">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm border border-gray-200">
                <Icon name={getOccasionIcon(occasion.type)} size={20} className="text-gray-600" />
              </div>
              <div>
                <h4 className="font-semibold text-gray-800 text-base">{occasion.title}</h4>
                <p className="text-sm text-gray-600">{occasion.recipient}</p>
                <p className="text-xs text-gray-500">{occasion.date}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className={`px-3 py-1 rounded-full text-sm font-semibold ${getUrgencyColor(occasion.daysLeft)}`}>
                {formatDaysLeft(occasion.daysLeft)}
              </div>
              <Button
                variant="primary"
                size="sm"
                onClick={() => handleFindGift(occasion)}
                className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg font-medium"
              >
                Find Gift
              </Button>
            </div>
          </div>
        ))}
      </div>

      {occasions.length === 0 && (
        <div className="text-center py-12">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Calendar" size={24} className="text-gray-400" />
          </div>
          <p className="text-gray-600 mb-2 font-medium">No upcoming occasions</p>
          <p className="text-sm text-gray-500 mb-4">Add important dates to never miss a celebration</p>
          <Button
            variant="outline"
            size="sm"
            iconName="Plus"
            iconPosition="left"
            onClick={onAddNew}
            className="text-gray-600 border-gray-300 hover:border-gray-400"
          >
            Add Occasion
          </Button>
        </div>
      )}
    </div>
  );
};

export default UpcomingOccasionsCard;